import React from 'react'
import { Text, Stack } from '@mantine/core'
import i18n from 'live/services/i18n'
import { IconChartBarPopular } from '@tabler/icons-react'

interface EmptyMetricsCardProps {
    metricType?: 'stages' | 'average'
}

const EmptyMetricsCard: React.FC<EmptyMetricsCardProps> = ({ metricType }) => {
    return (
        <Stack spacing="xs" align="center">
            <IconChartBarPopular size="3.75rem" color="var(--mantine-text-default)" />
            <Text size="xs" ta="center">
                {i18n('Try searching again with a different term or change the applied filters.')}
            </Text>
            <Text size="lg" ta="center" fw={500} lh="1.2" color="var(--mantine-text-default)">
                {metricType === 'stages' ? i18n('Stages completed') : i18n('AVG. Pump time per stage')}
            </Text>
            <Text size="xs" ta="center" tt="uppercase" fw={500} color="var(--mantine-text-subtle)">
                {i18n('In the last 24 hours')}
            </Text>
        </Stack>
    )
}

export default EmptyMetricsCard
